export default __webpack_public_path__ + "assets/notification.181f9dddbb323cfd3c307bbbb5794c2c.mp3";